<template>
  <router-view :systemData="systemData"></router-view>
</template>

<script>
import { getStatusForSystemsTickets, getSystemStatusById } from '@api'
import { hasTasks } from '../api/api'

export default {
  props: ['systemName', 'systemId'],
  data() {
    return {
      tasksInterval: null,
      systemData: null
    }
  },
  methods: {
    async getData() {
      this.systemData = await getSystemStatusById(this.systemId) 

      if (!this.$store.getters.isUser) {
        var result = await getStatusForSystemsTickets(this.systemId)

        // Ikonę w menu wybiera NavigationMenu na podstawie store — stan
        // ticketów trzyma store, a nie style ustawiane po id na <img>.
        this.$store.dispatch('system_hasTickets', result != 0)
      }

      this.getTasks()

      
    },
    getTasks() {
      hasTasks(this.systemId).then(result => {
        if (typeof(result) == typeof(true)) {
          this.$store.dispatch('system_hasTasks', result)
        }
      })
    }
  },
  mounted: async function () {
    this.getData();
    this.tasksInterval = setInterval(() => {
      this.getTasks()
    }, 1000 * 60)
  },
  destroyed() {
    clearInterval(this.tasksInterval)
    this.$store.dispatch('system_hasTasks', null)
    this.$store.dispatch('system_hasTickets', false)
  }
}
</script>


// WEBPACK FOOTER //
// src/views/SystemState.vue